<template>
  <div class="authbox">
    <div class="authbox__header">
      <h2 class="authbox__title">
        {{ $t('authbox.login_greetings') }}
      </h2>
      <div class="authbox__title-icon">
        <heart-filled-icon />
      </div>
    </div>
    <div class="authbox__form">
      <div class="authbox__social-buttons">
        <!-- <facebook-login
          :redirect-on-login-success="redirectOnLoginSuccess"
          @success="loginSuccess"
        /> -->
        <google-login
          :redirect-on-login-success="redirectOnLoginSuccess"
          @success="loginSuccess"
        />
      </div>
      <br />
      <h5>ou</h5>
      <br />
      <login-form
        :redirect-on-login-success="redirectOnLoginSuccess"
        @success="loginSuccess"
      />
    </div>
    <div class="authbox__register">
      {{ $t('authbox.new_users_title') }}
      <nuxt-link to="signup">{{ $t('authbox.create_an_account') }}</nuxt-link>
    </div>
  </div>
</template>

<script>
// import FacebookLogin from './facebook-login/FacebookLogin'
import GoogleLogin from './google-login/GoogleLogin'
import HeartFilledIcon from '~/components/icons/heart-filled/HeartFilledIcon.vue'
import LoginForm from '~/components/login-form/LoginForm'

export default {
  name: 'AuthBox',
  components: {
    HeartFilledIcon,
    LoginForm,
    // FacebookLogin,
    GoogleLogin,
  },
  props: {
    redirectOnLoginSuccess: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    loginSuccess() {
      this.$emit('success')
    },
  },
}
</script>

<style lang="scss">
@import '~/assets/css/btn.scss';

.authbox {
  text-align: center;

  .authbox__header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 30px;
  }

  .authbox__title {
    color: $v4_color_text;
    font-size: 24px;
  }
  .authbox__title-icon {
    margin-left: 5px;

    svg {
      fill: $v4_color_primary;
      width: 23px;
      vertical-align: bottom;
    }
  }
  .authbox__register {
    margin-top: 20px;
    text-align: center;

    a {
      color: $v4_color_primary;

      &:hover {
        text-decoration: none;
      }
    }
  }

  @media (min-width: $v4_tablet) {
    width: 340px;
    margin-left: auto;
    margin-right: auto;
  }

  .authbox__social-buttons {
    margin-top: 15px;
    display: flex;
    justify-content: center;
  }

  .authbox__social-buttons a {
    display: flex;
    justify-content: center;
    position: relative;
    padding: 0;
    border-radius: 4px;
    font-size: 14px;
    height: 50px;
    font-weight: bold;
    text-transform: none;
    line-height: 50px;
    width: calc(50% - 4px);
  }

  .authbox__social-icon {
    max-width: 12px;
    display: flex;
    margin-right: 10px;
    align-items: center;

    &.authbox__social-icon--big {
      max-width: 21px;
    }

    svg {
      width: 100%;
      height: auto;
    }
  }
}
</style>
